<template>
    <div class="productinfo-page row">
        <div class="mainInfo-part1 col-md-90" v-if="prductData.productPicList">
            <div class="mainInfo-part1-top" style="width:50%;">
                <div class="mainInfo-part1-laber">
                    <div>{{prductData.productPicList[0].title}}</div>
                    <pre v-html="prductData.productPicList[0].content"></pre>
                </div>
            </div>
            <img :src="prductData.productPicList[0].picUrl" :alt="prductData.productPicList[0].title" style="width: 100%;">
            <!-- <img class="mainInfo-part1-right" style="width:55%;" :src="prductMSG.info.productIMG" :alt="prductMSG.label">
            <img class="mainInfo-part1-bgm" src="../../static/link/img/infoB/bj.jpg"  alt="背景"> -->
        </div>
        <div class="mainInfo-part2 col-md-90" v-if="prductData.productPicList[1]">
            <div class="mainInfo-part2-content">
                <div class="mainInfo-part2-title" v-if="this.isEn == '0'">产品简介</div>
                <div class="mainInfo-part2-title" v-if="this.isEn == '1'">Product introduction</div>
                <pre class="mainInfo-part2-detail" v-html="prductData.productPicList[1].content"></pre>
                <div class="mainInfo-part2-right-bottom hover-common" v-if="prductData.productPicList[1].picUrl" @click="openVideoShow()">
                    <span class="el-icon-video-play" style="font-size:28px;"></span>
                    <span  v-if="this.isEn == '0'">观看产品视频</span>
                    <span  v-if="this.isEn == '1'">Watch product videos</span>
                </div>
            </div>
        </div>
         <div class="mainInfo-part3 col-md-90" v-for="(item,index) in prductData.productPicList" :key="index" v-if="item.showOrder.toString().indexOf('B')>-1">
            <img :src="item.picUrl" :alt="item.title">
        </div>
        <!-- <div class="mainInfo-part3 col-md-90" v-if="prductMSG!=''">
            <img :src="prductMSG.info.sloganImg" :alt="产品详情">
        </div> -->
        <div class="col-md-90" >
            <ProductParameter :parameter = "prductData.productParamList" :productCase = "prductData.productInfo.productCase" ></ProductParameter>
        </div>
        <videoCommon ref="videoProp" v-if="prductData.productPicList[1].picUrl" :videoTitle="''" :videoUrl = "prductData.productPicList[1].picUrl"></videoCommon>
    </div>
</template>


<script>
import ProductParameter from "@/components/ProductParameter";
import videoCommon from "@/components/videoCommon";

export default {
    name: "productinfoB",
    components:{
        ProductParameter,
        videoCommon
    },
    data() {
        return {
            prductMSG:"",//产品信息
            parameter:"",//参数
            prductData:{
                productInfo: {
                    productCase: ""
                },
                productPicList:[{
                    title:"",
                    content:"",
                    picUrl:"",
                    showOrder:""
                },{
                    title:"",
                    content:"",
                    picUrl:"",
                    showOrder:""
                }]
            },
        };
    },
  created() {
    this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0');
  },
  mounted(){
        let productNUM = this.$route.params.id;
        // productList&&productList.forEach(element => {
        //     element.children.forEach(item=>{
        //         if(item.value == productNUM){
        //             this.prductMSG = item;
        //             this.parameter = Object.assign({parameter:item.info.parameter},{DataDownload:item.info.DataDownload},{case:item.info.case});
        //         }
        //     })
        // });

        axios.post(`${window.$server_config.VUE_APP_WEBSITE_API}outer/product/getDetailInfo/${productNUM}`,{}
        ).then((response)=>{
            var res=response.data
            if(res.code== 200){
                this.prductData = res.data;
            }
        }).catch(res => {

        })
    },
    methods:{
        openVideoShow(){
            this.$refs.videoProp.openVideoShow();
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.productinfo-page{
    margin-top: 60px;
}

/* 第一部分 */
.mainInfo-part1{
    position: relative;
}
.mainInfo-part1 .mainInfo-part1-top{
    /* height: 380px; */
    position:absolute;
    left:0;
    top:0;

}
.mainInfo-part1 .mainInfo-part1-laber{
    padding-right: 20px;
    padding-top: 80px;
}
.mainInfo-part1 .mainInfo-part1-laber>div:nth-child(1){
    font-size: 36px;
    color: #000000;
    font-weight: 600;
    line-height: 42px;
}
.mainInfo-part1 .mainInfo-part1-laber>pre:nth-child(2){
    font-size: 14px;
    color: #2C2C2C;
    line-height: 26px;
    margin-top:12px;
}
/* .mainInfo-part1 .mainInfo-part1-laber>div:nth-child(2)>p{
    margin-bottom: 5rem;
} */
.mainInfo-part1 .mainInfo-part1-bottom{
    height: 324px;
    background: #7d7dd0;
    opacity: .4;
}
.mainInfo-part1 .mainInfo-part1-right{
    position: absolute;
    top: 0;
    right:0;
    width: 686px;
    z-index:2;
}
.mainInfo-part1-bgm{
    width:100%;
    margin-top:412px;
    z-index:1;
}
/* 第二部分 */
.mainInfo-part2 {
  /* width: 100%; */
  /* height: 400px; */
  text-align: center;
  position: relative;
}
.mainInfo-part2-content{
    max-width:700px;
    margin: 120px auto;
}
.mainInfo-part2-title{
    font-size: 32px;
    color: #2C2C2C;
    font-weight: bold;
    margin-bottom: 25px;
}
.mainInfo-part2-detail{
    color: #2C2C2C;
    line-height: 28px;
    text-align: left;
    font-size: 14px;
    white-space: pre-wrap;
    word-wrap: break-word;
    /* text-indent: 2em; */
}
/* 第三部分 */
.mainInfo-part3 {
    width: 100%;
    position: relative;
}
.mainInfo-part3 img{
    width:100%;
}
.mainInfo-part3-title {
    font-size: 48px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: left;
    text-align: center;
    position: absolute;
    top: 50%;
    margin-top: -24px;
    left: 50%;
    margin-left: -395px;
    width: 790px;
    height: 96px;
}

.mainInfo-part2-right-bottom {
  font-size: 16px;
  color: #00BBF8;
  cursor: pointer;
  width: fit-content;
}
.mainInfo-part2-right-bottom span {
  display: inline-block;
  vertical-align: middle;
}
.hover-common:hover{
  color: #1063ca;
}


/*  本页面布局方式    居中 */
.col-md-90{
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/productinfoB.vue